import React from 'react'
import { Loading as LoadingCortex } from '@tecsinapse/cortex-react'
import clsx from 'clsx'

interface LoadingProps {
  className?: string
}
export const Loading = ({ className }: LoadingProps) => (
  <div className={'relative ml-[50%]'}>
    <LoadingCortex
      className={clsx(
        'w-[4rem] h-[4rem] mt-[50px] -ml-[30px] text-primary-medium',
        className
      )}
    />
  </div>
)
